import React, { useState } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import GoogleMapReact from 'google-map-react';

import PropertySaleListingMapPin from './PropertySaleListingMapPin';

const PropertySaleListingMap = props => {
    const { hits } = props;
    const [activeInfoWindow, setActiveInfoWindow] = useState('');

    const villagePins = {};
    if (hits && hits.length > 0) {
        hits.forEach(hit => {
            const villageUniqueID = hit.village_id;
            if (villagePins[villageUniqueID]) {
                // exist, add
                const updatedVillageProperty = {
                    ...villagePins[villageUniqueID],
                    properties: [
                        ...villagePins[villageUniqueID].properties,
                        {
                            name: hit.name,
                            price: hit.price
                        }
                    ]
                };

                villagePins[villageUniqueID] = updatedVillageProperty;
            } else {
                // not exist, create
                const newVillageProperty = {
                    objectID: villageUniqueID,
                    villageName: hit.village,
                    street: hit.street ? hit.street : '',
                    state: hit.state,
                    suburb: hit.suburb,
                    postcode: hit.postcode,
                    villageUrl: hit.village_url ? hit.village_url : '',
                    _geoloc: hit._geoloc, // eslint-disable-line
                    properties: [{
                        name: hit.name,
                        price: hit.price
                    }]
                };

                villagePins[villageUniqueID] = newVillageProperty;
            }
        });
    }

    return (
        <div className="location-listing-map-container">
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyA_1xDTM9H4HOpeTDWz6N6B0p6r2oJElME' }}
                defaultCenter={{ lat: -28.024, lng: 140.887 }}
                defaultZoom={5}
            >
                {villagePins && Object.keys(villagePins).map(key => {
                    const hit = villagePins[key];

                    // eslint-disable-next-line no-underscore-dangle
                    if (!hit || !hit._geoloc) {
                        return null;
                    }

                    return (
                        <PropertySaleListingMapPin
                            key={hit.objectID}
                            lat={hit._geoloc.lat} // eslint-disable-line no-underscore-dangle
                            lng={hit._geoloc.lng} // eslint-disable-line no-underscore-dangle
                            hit={hit}
                            infoWindowActive={activeInfoWindow === hit.objectID}
                            handleInfoWindow={(value: string) => setActiveInfoWindow(value)}
                        />
                    );
                })}
            </GoogleMapReact>
        </div>
    );
};

export default connectHits(PropertySaleListingMap);
